<div id="gc-dg-Loader" class="gc-dg-mt-5 gc-dg-d-flex" style="display: none">
    <div class="gc-dg-d-inline">
        <div class="gc-dg-loader"></div>
    </div>

    <div class="gc-dg-d-inline gc-dg-text-2xl gc-dg-mr-5">Please Wait ...</div>
</div>
<p
    id="gc-dg-successMessage"
    class="gc-dg-success-message"
    style="display: none"
>
    Thank you, your payment has been successful
</p>

<!-- Submit Button -->
<button
    id="gc-dg-payNow"
    type="button"
    class="gc-dg-mt-5 gc-dg-mb-5 gc-dg-submit-btn"
>
    SET UP MY PROTECTION
</button>
